import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    EventEmitter, OnDestroy,
    OnInit,
    Output,
    ViewContainerRef
} from '@angular/core';
import {SpecialistChoseModalComponent} from '../specialist-chose-modal/specialist-chose-modal.component';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-specialist-add-button',
    templateUrl: 'specialist-add-button.component.html'
})

export class SpecialistAddButtonComponent implements OnInit, OnDestroy {
    @Output() selected = new EventEmitter<number>();

    private factory: ComponentFactory<SpecialistChoseModalComponent>;

    private componentRef: ComponentRef<SpecialistChoseModalComponent>;

    private destroyed$ = new Subject();

    constructor(
        private viewContainer: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
    ) {
    }

    ngOnInit() {
        this.factory = this.resolver.resolveComponentFactory(SpecialistChoseModalComponent);
    }

    onClick() {
        /**
         * Динамически инициализируем компонент редактирования карточки оборудования
         */
        if (this.componentRef) {
            this.destroyComponentRef();
        }
        this.componentRef = this.viewContainer.createComponent(this.factory);

        this.componentRef.instance.show();

        this.componentRef.instance.chosenId$.pipe(
            takeUntil(this.destroyed$),
            take(1),
        ).subscribe((id: number) => {
            if (id) {
                this.selected.next(id);
            }
            this.destroyComponentRef();
        });
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
    }

    private destroyComponentRef() {
        this.componentRef.destroy();
        this.componentRef = null;
    }
}
